module.exports = __webpack_public_path__ + "img/1D2424_565F66_4E555A_646C6E-256px.0b9ef4b5.png";